"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CustomizedShape = /** @class */ (function (_super) {
    __extends(CustomizedShape, _super);
    function CustomizedShape(props) {
        return _super.call(this, props) || this;
    }
    CustomizedShape.prototype.render = function () {
        var _a = this.props, cx = _a.cx, cy = _a.cy, fill = _a.fill, radius = _a.radius, borderColor = _a.borderColor, borderWeight = _a.borderWeight;
        return (react_1.default.createElement("g", null,
            react_1.default.createElement("circle", { cx: cx, cy: cy, r: radius, fill: fill, stroke: borderColor, strokeWidth: "" + borderWeight })));
    };
    ;
    return CustomizedShape;
}(react_1.default.Component));
exports.CustomizedShape = CustomizedShape;
